import React from "react";
import { Button, Container, Nav } from "react-bootstrap";
import resume from "../../../pdf/Resume_Debasree_Bhowmik.pdf";
import Slide from "react-reveal/Slide";
import ParticlesBg from "particles-bg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileDownload } from "@fortawesome/free-solid-svg-icons";
import bg from "../../../images/banner.png";
import { NavLink } from "react-router-dom";
import { faGithubSquare, faLinkedin } from "@fortawesome/free-brands-svg-icons";

const Banner = () => {
  const banner = {
    background: `url(${bg})`,
    backgroundColor: "#f5f5f595",
    backgroundBlendMode: "lighten, luminosity",
    height: "80vh",
    backgroundRepeat: "no-repeat",
    marginBottom: "100px",
  };

  const title = {
    fontFamily: "'Satisfy', cursive",
    color: "#033d44",
  };
  return (
    <Container
      fluid
      className="d-flex flex-column align-items-start align-items-md-end pt-5 mt-5 ps-2"
      style={banner}
    >
      {/* <ParticlesBg type="cobweb" bg={true} /> */}
      <Slide left cascade>
        <Container>
          <h1 className="display-1 fw-bold text-start text-md-end pe-5" style={title}>
            Hi <br />I am <br />
            Debasree Bhowmik
          </h1>
        </Container>
      </Slide>
      <Container fluid className=" d-flex justify-content-start justify-content-md-end pe-5 ">
        <Button variant="outline-dark">
          <FontAwesomeIcon
            className="fs-4 me-3"
            style={{
              color: "#033d44",
              fontWeight: "bold",
            }}
            icon={faFileDownload}
          />
          <a
            className="download-resume custom-btn fw-bold fs-5 "
            href={resume}
            download="Resume_Debasree_Bhowmik.pdf"
          >
            Download Resume
          </a>
        </Button>{" "}
      </Container>
      <Container fluid className=" d-flex justify-content-start justify-content-md-end pe-5 pt-3">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://github.com/Debasree97"
        >
          <FontAwesomeIcon
            className="fs-2 me-3"
            style={{
              color: "black",
              fontWeight: "bold",
            }}
            icon={faGithubSquare}
          />
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.linkedin.com/in/debasree-bhowmik-2b1a36226/"
        >
          <FontAwesomeIcon
            className="fs-2 me-3"
            style={{
              color: "#0a66c2",
              fontWeight: "bold",
            }}
            icon={faLinkedin}
          />
        </a>
      </Container>
    </Container>
  );
};

export default Banner;
